import { useAtomValue } from 'jotai'
import React from 'react'
import { TransactionResult } from 'src/common/contracts/hooks/useExecuteTx'
import useOpenExplorerLink from 'src/common/hooks/web3/useOpenExplorerLink'
import Button from 'src/common/ui-kit/Button/Button'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import { displayAmount } from 'src/common/utils/formatters/number'
import useCarbonBundleDepositState from '../Deposit/hooks/useCarbonBundleDepositState'
import { useTranslation } from 'react-i18next'
import { viccCountAtom } from '../bundle-store'
import useCarbon from 'src/common/queries/useCarbon'

interface CarbonBundleSuccessProps {
  onClose?(): void
  tx: TransactionResult
  mode: 'deposit' | 'withdraw'
}

const CarbonBundleSuccess: React.FC<CarbonBundleSuccessProps> = ({
  onClose,
  tx,
  mode,
}) => {
  const { t } = useTranslation('carbonBundles', {
    keyPrefix: 'successModal',
  })
  const { carbon } = useCarbon()
  const openExplorer = useOpenExplorerLink()

  const { receivedValue } = useCarbonBundleDepositState()

  const viccCount = useAtomValue(viccCountAtom)

  const handleViewTransaction = () => {
    openExplorer({
      type: 'tx',
      hash: tx.hash,
    })
  }

  let headingText: string
  let listItems: JSX.Element

  if (mode === 'deposit') {
    headingText = t('deposit.heading', {
      nftsCount: viccCount,
    })
    listItems = (
      <>
        <li>
          {t('deposit.list.issued', {
            receivedValue: displayAmount(receivedValue),
          })}
        </li>
        <li>{t('deposit.list.trade')}</li>
        <li>{t('deposit.list.burn')}</li>
        <li>{t('deposit.list.nonGoverned')}</li>
      </>
    )
  } else {
    headingText = t('withdraw.heading', {
      nftsCount: viccCount,
    })
    listItems = (
      <>
        <li>
          {t('withdraw.list.received', {
            count: viccCount || 0,
          })}
        </li>
        <li>{t('withdraw.list.nonGoverned')}</li>
      </>
    )
  }

  return (
    <div className='flex flex-col'>
      {carbon && (
        <TokenIcon size={64} className='mb-2 mx-auto' token={carbon} />
      )}
      <h2 className='modal-heading mb-2 text-center'>{headingText}</h2>
      <h3 className='modal-subtitle mb-2 text-center'>{t('whatHappens')}</h3>
      <ul className='marked-list mb-2'>{listItems}</ul>
      <div className='flex gap-4'>
        <Button
          className='w-full px-2'
          onClick={handleViewTransaction}
          variant='outlined'
        >
          {t('viewTransaction')}
        </Button>
        <Button className='w-full px-2' onClick={onClose}>
          {t('gotIt')}
        </Button>
      </div>
    </div>
  )
}

export default CarbonBundleSuccess
